module.exports = __webpack_public_path__ + "static/img/2wv3.d7a81ce7.png";